import { useRoutes } from 'react-router-dom';
import ErrorPage from 'utils/ErrorPage';
// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([
        LoginRoutes,
        MainRoutes,
        {
            path: '*',
            element: <ErrorPage status="notFound" primaryActionPath="/" primaryActionLabel="Return to sign in" />
        }
    ]);
}
